import { trigger, state, style, transition, animate } from '@angular/animations';

export const fadeIn = trigger('fadeIn', [
  state('void', style({ opacity: 0 })),
  transition(':enter', [animate('500ms ease-in', style({ opacity: 1 }))]),
]);

export const fadeInOut = trigger('fadeInOut', [
  state('void', style({ opacity: 0 })),
  transition(':enter', [animate('500ms ease-in', style({ opacity: 1 }))]),
  transition(':leave', [animate('300ms ease-out', style({ opacity: 0 }))]),
]);

export const expandCollapse = trigger('expandCollapse', [
  state(
    'collapsed',
    style({
      height: '0px',
      opacity: 0,
      display: 'none',
    })
  ),
  state(
    'expanded',
    style({
      height: '*',
      opacity: 1,
    })
  ),
  transition('collapsed <=> expanded', animate('400ms ease-in-out')),
]);
